import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
// import {getTPAID} from  '../global_helpers/sessionReturn.js';


const state = {
    templatesContext: {
        templatesList: null,
        templateStatus: null,
        tpaTemplateDefaults: null,
        agreementTemplates: null,
    },
};

const getters = {
   getTemplatesContext: (state) => state.templatesContext
};

const actions = {

    async updateTpaTemplateDefaults({commit, dispatch}, tmplDefaultObj){
        let authHeader = getAuthHeader();
        axios.post("/template/default/", tmplDefaultObj, authHeader)
        .then((res) => {
            console.log(res)
            dispatch('raiseMessage', 'Template default updated successfully!!', {root: true});
            commit('setTemplatesContext', res.data, {root: true})
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', 'There was an error updating template default!', {root: true});
        });
    },
    
    async downloadTemplate({dispatch}, templateObj){
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let auth = {
            Authorization: authToken
        };
        axios({
            method: 'get',
            url: "/template/download/?template_id="+templateObj.template_id+"&preview=false",
            responseType: 'blob',
            headers: auth
        })
        .then((res) => {
            var url = window.URL.createObjectURL(res.data);
              var a = document.createElement('a');
              a.href = url;
              a.download = templateObj.template_name+".docx";
              document.body.appendChild(a);
              a.click();
              a.remove();          
        }).catch((res) => {
            dispatch('raiseMessage','Oh No! There was an error downloading your template!', {root: true});
            console.error(res);
        });
    },
    
    async downloadPreview({dispatch}, templateObj){
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let auth = {
            Authorization: authToken
        };
        axios({
            method: 'get',
            url: "/template/?template_id="+templateObj.template_id,
            responseType: 'blob',
            headers: auth
        })
        .then((res) => {
            var url = window.URL.createObjectURL(res.data);
              var a = document.createElement('a');
              a.href = url;
              a.download = templateObj.template_name+".pdf";
              document.body.appendChild(a);
              a.click();
              a.remove();          
        }).catch((res) => {
            dispatch('raiseMessage','Oh No! There was an error downloading your preview!', {root: true});
            console.error(res);
        });
    },

    async uploadTemplate({dispatch, commit}, templateDetailObj) {
        let authHeader = getAuthHeader();
        dispatch('raiseMessage', 'Uploading template... This may take a moment.', {root: true});
        axios.post("/template/upload/", templateDetailObj, authHeader)
        .then((res) => {
            console.log(res)
            dispatch('raiseMessage','Successfully uploaded template!', {root: true});
            commit('setListsContext', res.data, {root: true})
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage','Oh No! There was an error uploading your template!', {root: true});
        });
    },
    
    async deleteTemplate({dispatch, commit}, templateDetailObj) {
        let authHeader = getAuthHeader();
        axios.delete("/template/?template_id="+templateDetailObj.template_id+"&entity_id="+templateDetailObj.entity_id+"&entity_type="+templateDetailObj.entity_type, authHeader)
        .then((res) => {
            console.log(res)
            dispatch('raiseMessage','Successfully deleted template!', {root: true})
            commit('setListsContext', res.data, {root: true})
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage','Oh No! There was an error deleting your template!', {root: true});
        });
    },
    
    async previewTemplate({dispatch}, templateObj){
        console.log('TEMPLATE PREVIEW HIT')
        console.log(templateObj)
        
        let authHeader = getAuthHeader()
        axios.get('/template/preview/?template_id='+templateObj.template_id, authHeader).then((res) => {
            console.log(res)

        })
        
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'Oh No! There was an error starting your preview download!', {root: true})
        })
    },
    
    async uploadTemplate_multipart({dispatch}, templateDetailObj) {

        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        axios({
            method: 'post',
            url: "/template/upload/",
            headers: {
                Authorization: authToken,
                'Content-Type': 'multipart/form-data'
            },
            data: templateDetailObj
        })
        
        .then(
            dispatch('raiseMessage','Successfully uploaded template!', {root: true})
        )        
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage','Oh No! There was an error uploading your template!', {root: true});
        });
    },
    
};

const mutations = {
    
};

export default {
    state,
    getters,
    actions,
    mutations
};